/**
 * 匿名コンサルホットライン 共通文言
 */
export const hotlineText = {
    /**
     * ボタンの文言
     */
    action: {
        accept: () => '承諾する',
        bulkCancel: () => '一括キャンセルする',
        cancel: () => '相談をキャンセルする',
        changeSchedule: () => '相談日程を変更する',
        copyInvitationLink: () => '招待リンクをコピー',
        operationCheck: () => '動作確認を行う',
        startMeeting: () => '相談を開始する',
    },
    /**
     * 項目の名前
     */
    label: {
        cancelReason: () => 'キャンセル理由',
        interviewTime: () => '相談時間の指定',
        interviewedFromAt: () => '相談開始日時',
    },
    /**
     * 文章
     */
    sentence: {
        alertChatClose: (isCancel) => `チャットは相談${isCancel ? 'キャンセル' : '完了'}後の一営業日後の24：00に閉じ、使用できなくなります`,
    },
};
